import { EditableGrid, EditorField } from "@/components/common/EditableGrid";
import { ShowAccordionSection } from "@/components/common/ShowAccordionSection";
import { ResourceName } from "@/types";

export const ClaimItemFinancialImpact = () => {
  const claimItemFields: EditorField[] = [
    { source: "paid_amount", type: "dollar" },
    { source: "billed_amount", type: "dollar" },
    { source: "eligible_amount", type: "dollar" },
    { source: "member_oop" },
    // #7348: member cost-share components from the carrier feed (not derived
    // from the policy); the API now applies them on linked and unlinked lines.
    { source: "deductible_amount", type: "dollar" },
    { source: "coinsurance_amount", type: "dollar" },
    { source: "copay_amount", type: "dollar" },
  ];

  return (
    <ShowAccordionSection label="Financial Impact" defaultExpanded>
      <EditableGrid fields={claimItemFields} recordType={ResourceName.CLAIM_ITEMS} />
    </ShowAccordionSection>
  );
};
